import $ from "jquery";
import { Toast } from "bootstrap";
import { saveAs } from "file-saver";

export const normalizePath = (path = "") => path.toLowerCase().replace(/\s+/g, " ").trim();
export function normalizeUrlPath(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");
}
export function showWishListAddToaster() {
  var toastEl = document.getElementById("wishlistadded");
  var toastAdd = new Toast(toastEl);
  var toastE2 = document.getElementById("wishlistremove");
  var toastremove = new Toast(toastE2);
  toastAdd.show();
  toastremove.hide();
}
export function showWishListCreateToaster() {
  var toastEl = document.getElementById("newListCreate");
  var toastAdd = new Toast(toastEl);
  var toastE2 = document.getElementById("wishlistremove");
  var toastremove = new Toast(toastE2);
  toastAdd.show();
  toastremove.hide();
}
export function showFavouriteToaster() {
  var toastEl = document.getElementById("wishlistcontainer");
  var toastAdd = new Toast(toastEl);
  var toastE2 = document.getElementById("wishlistremove");
  var toastremove = new Toast(toastE2);
  toastAdd.show();
  toastremove.hide();
  //showWishListAddToaster();
}

export function showWishListRemoveToaster() {
  var toastEl = document.getElementById("wishlistcontainer");
  var toastAdd = new Toast(toastEl);
  var toastE2 = document.getElementById("wishlistremove");
  var toastremove = new Toast(toastE2);
  toastAdd.hide();
  toastremove.show();
}

export function validateNumber(event) {
  var charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  return true;
}
export function isNumberKey(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  return true;
}

export function isNumber(e) {
  e = e ? e : window.event;
  var charCode = e.which ? e.which : e.keyCode;
  if (e.charCode == 8 || e.charCode == 9) {
    return false;
  }
  if (e.charCode >= 46 || e.charCode <= 57) {
    return true;
  } else return true;
} //  alert("test");

export function matchtxt(given_string, pattern) {
  given_string = given_string.toLowerCase();
  pattern = pattern.toLowerCase();
  return given_string.includes(pattern);
}

export function PageCompare(URL) {
  var currentPage = window.location.pathname;
  return URL.includes(currentPage);
}

export function isValidPhoneNumber(e) {
  e = e ? e : window.event;
  var charCode = e.which ? e.which : e.keyCode;
  if (e.charCode == 8 || e.charCode == 9) {
    return false;
  }
  if (e.charCode >= 46 || e.charCode <= 57) {
    return true;
  } else return true;
} //  alert("test");

export function ValidateEmail(mail) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true;
  }
  return false;
}

export function isPhoneNumber(p) {
  var phoneRe = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;
  var digits = p.replace(/\D/g, "");
  return phoneRe.test(digits);
}
export function isNumberOnly(p) {
  var digits = p.replace(/\D/g, "");
  return digits;
}
export function isValidNumber(value) {
  if (/^\d+$/.test(value)) {
    return true;
  }
  return false;
}
export function encodeFilters(obj) {
  try {
    if (obj && Object.entries(obj).length > 0) {
      const jsonStr = JSON.stringify(obj);
      const utf8Bytes = new TextEncoder().encode(jsonStr);
      const binaryStr = Array.from(utf8Bytes)
        .map((b) => String.fromCharCode(b))
        .join("");
      const base64 = btoa(binaryStr);
      return base64;
    } else return "";
  } catch (e) {
    console.error(e);
    return "";
  }
}
export function decodeFilters(params) {
  try {
    if (params) {
      let encoded = params.split("&").pop();
      encoded = encoded.startsWith("?") ? encoded.slice(1) : encoded;
      const base64 = encoded;
      const binaryStr = atob(base64);
      const bytes = new Uint8Array(Array.from(binaryStr).map((ch) => ch.charCodeAt(0)));
      const jsonStr = new TextDecoder().decode(bytes);
      return JSON.parse(jsonStr);
    } else return "";
  } catch (e) {
    console.error("Decode failed:", e);
    return "";
  }
}
export function base64Decode(encodedString) {
  try {
    if (encodedString == "") return encodedString;
    if (encodedString == null || encodedString == "null") return null;
    const decodedString = atob(encodedString);
    return decodedString;
  } catch (error) {
    return null;
  }
}
export function base64Encode(str) {
  const utf8Bytes = new TextEncoder().encode(str);
  return btoa(String.fromCharCode(...utf8Bytes));
}

export function getSiteBaseUrl() {
  return process.env.REACT_APP_publicUrl || window.location.origin;
}

// eBook links reach the client in several shapes depending on the endpoint:
//   https://www.wes.com.au/View_eBook.aspx?ebookpath=/mediapub/ebook/wescat2023/1082/  (product attributes)
//   https://www.wes.com.au/view_ebook.aspx?ebookpath=/mediapub/ebook/x/                (Category/Flyer controllers)
//   /mediapub/ebook/x/                                                                 (already stripped server-side)
// getEbookPath reduces all of them to the bare document path.
const EBOOK_ROUTE_PREFIXES = [/^\/?view_ebook\.aspx\?ebookpath=/i, /^\/?view_ebook\/ebookpath=/i];

export function getEbookPath(link) {
  if (!link || typeof link !== "string") return null;
  let path = link.trim().replace(/\\/g, "/");
  if (path === "" || path === "null" || path === "undefined") return null;
  path = path.replace(/^https?:\/\/[^/]*wes\.com\.au/i, "").replace(/wes_secure_files\//gi, "");
  for (const prefix of EBOOK_ROUTE_PREFIXES) {
    if (prefix.test(path)) {
      path = path.replace(prefix, "");
      break;
    }
  }
  path = "/" + path.replace(/^\/+/, "");
  return path === "/" ? null : path;
}

// Builds the SPA's own eBook route from any of the shapes above, so the link stays on the
// current host instead of jumping to production. Returns null when there is no eBook.
export function toEbookRoute(link) {
  if (typeof link === "string" && /^\/viewebook\//i.test(link.trim())) return link.trim(); // already a route
  const path = getEbookPath(link);
  return path ? "/ViewEbook/" + encodeURIComponent(base64Encode(path)) : null;
}

// Attribute values come from the DB with the live site hardcoded, e.g.
// <a href='https://www.wes.com.au/View_eBook.aspx?ebookpath=/mediapub/ebook/wescat2023/1082/'>.
// Point them at the current site and at the SPA's own /ViewEbook route so the links
// work on local/dev/staging as well as production. cdn.wes.com.au is left untouched.
export function resolveWesLinks(html) {
  if (!html || typeof html !== "string") return html;
  return html
    .replace(/https?:\/\/(?:www\.)?wes\.com\.au/gi, getSiteBaseUrl())
    .replace(/\/View_eBook\.aspx\?ebookpath=([^'"\s&>]+)/gi, (match, ebookPath) => toEbookRoute(ebookPath) || match);
}

export function IsNumberKey(v) {
  const numericValue = v.replace(/[^0-9]/g, "");
  return numericValue;
}
export function IsNumberKeyWithoutZero(v) {
  //console.log("v", v);
  if (v.startsWith("0") && String(v).length == 1) {
    return "";
  } else {
    const numericValue = v.replace(/[^0-9]/g, "");
    // console.log("numericValue", numericValue);
    return numericValue;
  }
}
export function SmsNumberStart04(v) {
  if (v.startsWith("0") && String(v).length == 1) {
    const numericValue = v.replace(/[^0-9]/g, "");
    if (String(numericValue)) return numericValue.slice(0, 10);
  } else if (v.startsWith("04") && String(v).length > 1) {
    const numericValue = v.replace(/[^0-9]/g, "");
    if (String(numericValue)) return numericValue.slice(0, 10);
  } else if (v.startsWith("0") && String(v).length > 1) {
    return "0";
  } else return "";
}

export function poNumberStartWith(str, startWith) {
  if (str === "") return "";
  const v = String(str);
  const n = String(startWith);
  const regex = new RegExp(`^${startWith}.*`);
  const isValid = regex.test(v) || n.startsWith(v);

  return isValid ? v : poNumberStartWith(str.slice(0, -1), startWith);
}

export function isNumeric(inputtxt) {
  var letters = /^[A-Z a-z]+$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
}
export function isAlphaNumericAnd_dot(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-zA-Z0-9.-]/g, "");
  return numericValue;
}
export function isAlphaNumericAndSpace_(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-zA-Z0-9 -]/g, "");
  return numericValue;
}
export function isAlphaNumericAnd_(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-zA-Z0-9-]/g, "");
  return numericValue;
}
export function isAlpha(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-z A-Z]/g, "");
  return numericValue;
}
export function isAlphaNumeric(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-z A-Z0-9.,/-]/g, "");
  return numericValue;
}
export function isAlphaNumericStrict(inputtxt) {
  const numericValue = inputtxt.replace(/[^a-zA-Z0-9]/g, "");
  return numericValue;
}
export function validateWebsite(value) {
  const urlRegex = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,})(\/\S*)?$/;
  return urlRegex.test(value);
}
export function validateMonthYear(input) {
  const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
  if (!regex.test(input)) {
    return false;
  }

  const [month, year] = input.split("/").map(Number);

  const now = new Date();
  const currentMonth = now.getMonth() + 1;
  const currentYear = now.getFullYear() % 100;

  if (year > currentYear || (year === currentYear && month >= currentMonth)) {
    return true;
  }

  return false;
}

export function cardExpiryError(input) {
  if (!input) return "Card Expiration date is required";
  if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(input)) return "Enter a valid expiration date (MM/YY)";
  if (!validateMonthYear(input)) return "This card has expired";
  return "";
}

export function ConvertToFloat(value) {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parseFloat(parsed).toFixed(2);
}

export function ConvertToBoolean(value) {
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }
  return Boolean(value);
}

export function cardMonthYear(value) {
  const inputValue = value.replace(/[^0-9/]/g, "");
  if (!inputValue.includes("/")) {
    return inputValue.length > 2 ? `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}` : inputValue;
  }
  const [monthPart, ...rest] = inputValue.split("/");
  const month = monthPart.slice(0, 2);
  const year = rest.join("").slice(0, 2);
  if (month.length === 1 && month !== "0" && year === "") {
    return `0${month}/`;
  }
  return `${month}/${year}`;
}
export function IsNumberKeyWithoutZeroCopyPast(v) {
  // v = v.replace("-", "");
  var t = v;
  if (String(v).includes(" ") && !String(v).includes("\n")) {
    var txt = v.split(" ");
    var numberonly = IsNumberKeyWithoutZero(txt[1].replace("-", ""));
    t = txt[0] + " " + numberonly;
  } else if (String(v.replace("-", "")).includes("\n")) {
    const tx = String(v.replace("-", "")).split("\n");
    var len = tx.length;
    var lastEnterTxt = tx[parseInt(len) - 1];
    if (lastEnterTxt !== "") {
      if (lastEnterTxt.includes(" ")) {
        var txt2 = lastEnterTxt.split(" ");
        numberonly = IsNumberKeyWithoutZero(txt2[1].replace("-", ""));
        lastEnterTxt = txt2[0] + " " + numberonly.replace("-", "");
      }
      tx[parseInt(len) - 1] = lastEnterTxt.replace("-", "");
      t = tx.join("\n");
    }
  }
  return t;
}

export function PaymentGatewayInit() {}

export function getPageName() {
  var cUrl = String(window.location.pathname).toLowerCase().split("/")[1];
  return cUrl;
}

export function collapseNewCard(id) {
  //collapsecreditcard
  var divContent = document.getElementById(id);
  var ariaid = $(divContent).attr("aria-controls");
  var ariaContent = document.getElementById(ariaid);
  if ($(divContent).hasClass("collapsed")) {
    // If the class exists, remove it
    $(divContent).removeClass("collapsed");
    $(divContent).attr("aria-expanded", "true");

    if ($(ariaContent).hasClass("show") == false) {
      $(ariaContent).addClass("show");
    }
  }
}

export function FilterSpecialCharacter(inputString) {
  var regex = /[^a-zA-Z0-9.\s]/g;
  var replacedString = inputString.replace(regex, "");
  return replacedString;
}

export function replaceSpecialCharacter(inputString, replaceString = " ") {
  const numericValue = inputString.replace(/[^a-zA-Z0-9]/g, replaceString);
  return numericValue;
}

export function FormAnimate(e) {
  $(e).parent().addClass("label-animate");
}

export function FormAction() {
  $('.form-control.custom_input[name="textbox"]').click(function () {
    $(this).parent().addClass("label-animate");
  });

  $('.form-control.custom_input[name="textbox"]').focus(function () {
    $(this).parent().addClass("label-animate");
  });

  $('.form-control.custom_input[name="textbox"]').blur(function () {
    if ($(this).val() == "") {
      $(this).parent().removeClass("label-animate");
    } // Remove the "focused" class
  });

  // Add focus event listener (optional)
  //$('.form-control.custom_input[name="textbox"]').focus(function() {
  //  $(this).addClass("label-animate"); // Add the "focused" class
  //});

  $(window).click(function (event) {
    if (!$(event.target).is(".form-control")) {
      $(".form-control").each(function () {
        if ($(this).val() == "") {
          $(this).parent().removeClass("label-animate");
        }
      });
    }
  });
}
export function CheckErrorCode(txt) {
  var rValue = "";
  try {
    var errorObject = JSON.parse(process.env.REACT_APP_LoginError);
    var dCode = base64Decode(txt);
    var errormsg = errorObject[dCode];
    if (errormsg !== "") {
      rValue = errormsg;

      if (window.location.pathname == "/") {
        document.getElementById("divLoginmySidenav").style.width = "378px";
        document.getElementById("show_all_nav2").style.display = "block";
      }
    }
  } catch {
    rValue = "";
  }
  return rValue;
}
export function isValidArray(array) {
  return Array.isArray(array) && array.length > 0;
}

// Finds the linked-category entry for a given category (matched by categoryId, with a normalized-URL fallback).
export function findLinkedCategory(cat, linkedCategoryData) {
  if (!cat || !isValidArray(linkedCategoryData)) return null;
  const catUrl = String(cat.url || cat.categoryUrl || "")
    .replace(/^\/|\/$/g, "")
    .toLowerCase();
  return linkedCategoryData.find(
    (l) =>
      (cat.categoryId && l.categoryId == cat.categoryId) ||
      (catUrl &&
        String(l.categoryUrl || "")
          .replace(/^\/|\/$/g, "")
          .toLowerCase() == catUrl),
  );
}

// Returns the URL a category link should navigate to: the linked category's URL (normalized to "/path/")
// when a linked entry exists, otherwise the category's own URL. The displayed name must stay the original.
export function resolveCategoryUrl(cat, linkedCategoryData) {
  const linked = findLinkedCategory(cat, linkedCategoryData);
  if (linked?.linkedCategoryUrl) {
    return "/" + String(linked.linkedCategoryUrl).replace(/^\/|\/$/g, "") + "/";
  }
  return cat?.url ?? cat?.categoryUrl;
}

export const resolveImageUrl = (src) => {
  if (!src) return process.env.REACT_APP_NoImage; // Handle null/undefined cases
  return src.startsWith("http") ? src : `${process.env.REACT_APP_IMAGE_URL || ""}${src}`;
};

export class CartToastObject {
  constructor(prdcode, prdimg, prddesc, prdprice, prdqty) {
    this.productCode = prdcode;
    this.prodImage = prdimg;
    this.description = prddesc;
    this.price = prdprice;
    this.qty = prdqty;
  }

  // Optional method to get details as JSON
  toJson() {
    return {
      prodImage: this.prodImage,
      description: this.description,
      qty: this.qty,
      price: this.price,
      productCode: this.productCode,
    };
  }
}

export const formatAddress = (obj, keys) => {
  return keys
    .map((key) => {
      if (key === "shipPhone" && obj[key]) {
        return `Phone: ${obj[key].trim()}`; // Special format for phone
      }
      if (key === "billPhone" && obj[key]) {
        return `Phone: ${obj[key].trim()}`; // Special format for phone
      }
      return obj[key]; // Default formatting
    })
    .filter((value) => value && value.trim() !== "") // Exclude empty/null values
    .map((value) => value.trim().toLowerCase()); // Trim spaces
};

export function CheckPoBox(address) {
  var sttr = String(address).toLowerCase().replaceAll(" ", "");
  if (sttr.includes("pobox") || sttr.includes("po box")) {
    return true;
  } else {
    return false;
  }
}

export function showCardDetails() {
  $(".card-details-list1").show("slow");
  $(".wallet-details-list").hide("slow");
  $(".acc-details-list1").hide("slow");
}

export function showMyWalletClick() {
  $(".wallet-details-list").show("slow");
  $(".card-details-list1").hide("slow");
  $(".acc-details-list1").hide("slow");
}

export function payAccountClick() {
  $(".wallet-details-list").hide("slow");
  $(".card-details-list1").hide("slow");
  $(".acc-details-list1").show("slow");
}
export function hideOtherClick() {
  $(".card-details-list1, .wallet-details-list").hide("slow");
}
export function StringToObject(val) {
  return String(val)
    .toUpperCase()
    .replace(/[^a-zA-Z0-9]/g, "");
}

// export function ExcelUpload(e) {
//   var reader = new FileReader();
//   reader.readAsArrayBuffer(e.target.files[0]);
//   reader.onload = export function(e) {
//     var data = new Uint8Array(reader.result);
//     var wb = XLSX.read(data, { type: "array" });
//     var sheet_name_list = wb.SheetNames;
//     var dataj = XLSX.utils.sheet_to_json(wb.Sheets[sheet_name_list[0]], {
//       raw: true,
//       defval: null
//     });

//     dataj.map(export function(r) {
//       console.log(r);
//     });
//   };
// }
export async function smsNumberChangeClick() {
  $(".sms-sent-notify").slideUp("slow");
  $(".changing-sms-notify").slideDown("slow");
  $("#textbox-sms-notify").focus();
}

export async function smsNumberUpdateClick() {
  $(".sms-sent-notify").slideDown("slow");
  $(".changing-sms-notify").slideUp("slow");
}
export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const scrollToFocuse = (element, delay = 0, offset = 0) => {
  try {
    setTimeout(() => {
      const overlay = element?.closest?.(".product-overlay");
      if (overlay) {
        const overlayTop =
          element.getBoundingClientRect().top - overlay.getBoundingClientRect().top + overlay.scrollTop - offset;
        overlay.scrollTo({ top: overlayTop, behavior: "smooth" });
        return;
      }
      let top = 200;
      if (element && element.getBoundingClientRect()) {
        top = element.getBoundingClientRect().top + window.pageYOffset - offset;
      }
      window.scrollTo({ top, behavior: "smooth" });
    }, delay);
  } catch (e) {
    console.error(e);
  }
};

export function showForgotPasswordEmptyMail() {
  var toastEl = document.getElementById("emailErrorMsg");
  var toastAdd = new Toast(toastEl);
  toastAdd.show();
}
export function handleShowSideBar() {
  $(".sidebar-wrap").addClass("sidebar-opened");
}
export function handleCloseSideBar() {
  $(".sidebar-wrap").removeClass("sidebar-opened");
}
export const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
};

export function capitalized(text) {
  try {
    return String(text).charAt(0).toUpperCase() + String(text).slice(1).toLowerCase();
  } catch (e) {
    return text;
  }
}

export function capitalizeFirstLetter(text) {
  if (text && text.length) {
    return `${text[0].toUpperCase()}${text.slice(1)}`;
  }
  return "";
}

export const downloadJson2Excel = async ({ jsonData, fileName }) => {
  try {
    const XLSX = await import("xlsx");
    const worksheet = XLSX.utils.json_to_sheet(jsonData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, fileName);

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `${replaceSpecialCharacter(fileName.toLowerCase(), "_")}.xlsx`);
  } catch (e) {
    console.error(e);
  }
};

export const LOGIN_RETURN_URL_KEY = "loginReturnUrl";

export function setLoginReturnUrl() {
  const path = String(window.location.pathname || "") + String(window.location.search || "");
  if (!path.startsWith("/") || path.startsWith("//")) return;
  if (path.toLowerCase().includes("/login")) return;
  sessionStorage.setItem(LOGIN_RETURN_URL_KEY, path);
}

export function getLoginReturnUrl() {
  const path = sessionStorage.getItem(LOGIN_RETURN_URL_KEY);
  if (!path || !path.startsWith("/") || path.startsWith("//")) return "";
  return path;
}

export function clearLoginReturnUrl() {
  sessionStorage.removeItem(LOGIN_RETURN_URL_KEY);
}

export function readCarouselPosition(event) {
  const owl = event?.relatedTarget;
  if (!owl || typeof owl.current !== "function" || typeof owl.items !== "function") return null;
  const count = owl.items().length;
  const visible = owl.settings?.items ?? 1;
  const current = owl.current() ?? 0;
  return { atStart: current <= 0, atEnd: current + visible >= count };
}
